import React, { useEffect, useState, useRef } from "react";
import logo from "../../assets/logo.png";
import bgVideo from "../../assets/finance-bg.mp4";
import AOS from "aos";
import "aos/dist/aos.css";

const PageLoader = ({ loading }) => {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        if (!loading) {
            const t = setTimeout(() => setVisible(false), 600);
            return () => clearTimeout(t);
        }
    }, [loading]);
    if (!visible) return null;
    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: '#0d0a06',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.25rem',
            transition: 'opacity 0.6s ease',
            opacity: loading ? 1 : 0,
        }}>
            <img
                src={logo}
                alt="Logo"
                style={{
                    width: 48,
                    height: 48,
                    objectFit: 'contain',
                    animation: 'pulse 1.5s infinite'
                }}
            />
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, fontFamily: 'DM Sans, sans-serif', letterSpacing: '0.1em' }}>
                TUMAINI LETU
            </p>
        </div>
    );
};

export default PageLoader;